import React  from 'react';
import './App.css';
import './Court.css';
import QRCode from "react-qr-code";
import CourtLang from './CourtLang.json';

class CourtSettings extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			courtID: 0,
			courtName: "",
			qrcodeID: "",
		}
	}

	componentDidMount() {
		var courtID = this.props.courtID;
		this.serverGetCourtData(courtID);
	}

	async serverGetCourtData(courtID) {
		
		if (courtID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcourtdata?courtid=" + courtID;
		
		var jsonObj = null;
		var courtName = "";
		var qrcodeID = "";
		
		try {
			var res = await fetch(url);
			jsonObj = await res.json();
			courtName = jsonObj.courtName;
			qrcodeID = jsonObj.qrcodeID;
		} catch (err) {
		}
		
		this.setState({
			courtName: courtName,
			qrcodeID: qrcodeID,
		});
	}
	
	renderQRCode() {
		
		var baseURLAPI = this.props.baseURLAPI;
		var qrcodeID = this.state.qrcodeID;
		var url = baseURLAPI + "/perma?q=" + qrcodeID;
		
		return (
			<div>
				<QRCode
					size={256}
					style={{ height: "auto", maxWidth: "512px", width: "512px" }}
					value={url}
					viewBox={`0 0 256 256`}
				/>
				<div style={{height: "20px"}}></div>
				<div>{url}</div>
			</div>
		);
	}
	
	render() {

		var courtName = this.state.courtName;
		var locationName = this.props.locationName;

		return (
			<div className="CourtSettingsTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="CourtSettingsTitle">{locationName} / {courtName} - {this.props.getLang(CourtLang, "courtSettings")}</div>
				<div style={{height: "10px"}}></div>
				{this.renderQRCode()}
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
}

export default CourtSettings;
